import axios from 'axios'
import qs from 'qs'

import { reverse } from 'named-urls'

import { getBaseURL, getMarketPlaceToken } from './env'
import { routes } from 'Routes'
import { routes as supplierRoutes } from 'SupplierRoutes'
import { routes as guestRoutes } from 'GuestRoutes'
import * as service from './index'
import history from 'service/history'
import changeCaseKeys from 'helpers/changeCase/keys'
import serverError from 'helpers/serverError'
import constants from 'constants/index'

export const create = (projectTag, treatError = true) => {
  // Rede de segurança: sem timeout, um firewall que faz DROP silencioso deixa a
  // promise pendurada para sempre. O valor vem do catálogo local, não do
  // endpoint: as instâncias são criadas na carga do módulo, antes de existir
  // sessão para buscar o catálogo remoto. Tag sem entrada mantém o default do
  // axios, para não alterar o comportamento de quem ainda não foi mapeado.
  const serviceEntry = Object.values(constants.externalServices.CATALOG).find(
    (entry) => entry.projectTag === projectTag,
  )

  let api = axios.create({
    baseURL: getBaseURL(projectTag),
    ...(serviceEntry?.timeoutMs && { timeout: serviceEntry.timeoutMs }),
  })
  let authToken = ''
  let authSupplierToken = ''

  api.interceptors.request.use((reqConfig) => {
    if (projectTag === 'dponet') {
      authSupplierToken = service.dponet.auth.getSupplierInviteToken()
      authToken = service.dponet.auth.getToken()
    }

    if (projectTag === 'marketPlace') {
      authToken = getMarketPlaceToken()
    }

    if (projectTag === 'cookies') {
      authToken = service.cookies.auth.getToken()
    }

    if (projectTag === 'supplierPortal') {
      authToken = service.supplierPortal.auth.getToken()
    }

    if (projectTag === 'guestPortal') {
      authToken = service.guestPortal.auth.getToken()
    }

    if (projectTag === 'trainingPortal') {
      authToken = service.trainingPortal.auth.getToken()
    }

    reqConfig.headers = reqConfig.headers || {}

    if (!reqConfig.headers.Authorization) {
      reqConfig.headers.Authorization = authToken ? `${authToken}` : undefined
    }
    reqConfig.headers.Authorizationsupplier = authSupplierToken
      ? `${authSupplierToken}`
      : undefined
    reqConfig.headers.crossDomain = true
    if (!(reqConfig.data instanceof FormData)) {
      reqConfig.data = changeCaseKeys.snakeCase(reqConfig.data)
    }
    reqConfig.params = changeCaseKeys.snakeCase(reqConfig.params)

    reqConfig.paramsSerializer = (params) => {
      return qs.stringify(params, {
        arrayFormat: 'brackets',
        encode: false,
      })
    }

    return reqConfig
  })

  api.interceptors.response.use(
    (resp) => changeCaseKeys.camelCase(resp),
    (error) => {
      if (treatError) {
        if (error?.response?.status === 401) {
          if (projectTag === 'guestPortal') {
            service.guestPortal.auth.logout(
              null,
              window.location.pathname.split('/')[1],
            )
          } else {
            service.dponet.auth.logout()
          }
          return Promise.reject(changeCaseKeys.camelCase(error))
        }
        if (error?.response?.status === 404) {
          if (projectTag === 'supplierPortal') {
            history.push(supplierRoutes.notFound)
          } else if (projectTag === 'guestPortal') {
            const organizationSlug = window.location.pathname.split('/')[1]
            history.push(
              organizationSlug
                ? reverse(guestRoutes.notFoundWithSlug, { organizationSlug })
                : guestRoutes.notFound,
            )
          } else {
            history.push(routes.notFound)
          }
          return Promise.reject(changeCaseKeys.camelCase(error))
        }

        if (error?.response?.status === 403) {
          history.push(routes.forbidden)
          return Promise.reject(changeCaseKeys.camelCase(error))
        }

        if (error?.response?.status >= 500) {
          const eventId = error?.response?.headers?.['x-sentry-id']
          history.push({
            pathname: routes.serverError,
            search: serverError.buildSearch({
              eventId,
              occurredAt: new Date().toISOString(),
            }),
          })
          return Promise.reject(changeCaseKeys.camelCase(error))
        }
      }
      return Promise.reject(changeCaseKeys.camelCase(error))
    },
  )

  return api
}

const api = { create }

export default api
